module.exports = __webpack_public_path__ + "img/My-Activities.1ced7f71.jpg";